<template>
  <div class="saved-orders-container" v-if="isLoaded">
    <div class="h2">Текущий заказ</div>
    <div v-if="savedForms.length" class="block_flex">
      <div v-for="form in savedForms" :key="form.id" class="saved-order-card">
        <div class="order-header">
          <div class="close_form" @click="deleteForm()"></div>

          <span class="order-date prew" >Дата создания:</span><span style="font-size: 12px;"> {{ new Date(form.created).toLocaleString() }}</span>
        </div>
        <div class="order-details">
          <div><span class="prew">Номер заказа:</span> <span>{{ form.number && form.number || 'Нет номера' }}</span></div>
          <div><span class="prew">Текущий источник:</span> <span>{{ form.orderMethod && form.orderMethod.label || 'Неизвестный источник' }}</span></div>
          <div><span class="prew">Телефон клиента:</span> <span>{{ form.phone || 'Не указан' }}</span></div>
          <button @click="openSavedForm(form.id)" class="open-order-button">Открыть заказ</button>
        </div>
      </div>
    </div>
    <p v-else class="no-orders">Нет текущих заказов.</p>
  </div>
</template>



<script>
import { mapState } from 'vuex';

export default {
  name: 'SavedOrders',
  data() {
    return {
      isLoaded: false // флаг, что данные загружены
    };
  },
  computed: {
    ...mapState('savedFormsModule', ['savedForms'])
  },
  
  methods: {
    openSavedForm(formId) {
      const form = this.savedForms.find(f => f.id === formId);
      if (!form) {
        console.error(`Форма с id ${formId} не найдена.`);
        return;
      }

      if (form.idorder) {
        this.$router.push({ 
          name: 'OrderEdit', 
          params: { 
            orderId: form.idorder, 
            site: (form.site && form.site.value) || ''
          }
        }).catch(err => {
          if (err.name !== 'NavigationDuplicated') throw err;
        });
      } else {
        localStorage.setItem('currentFormId', formId);
        this.$router.push({ name: 'OrderCreate', params: { formId } })
          .catch(err => {
            if (err.name !== 'NavigationDuplicated') throw err;
          });
      }
    },
    
    deleteForm() {
      this.$store.dispatch('savedFormsModule/clearSavedForms');
      this.$store.commit('clearProducts'); // Очистка продуктов через Vuex мутацию
    },
  },
  mounted() {
    this.$store.dispatch('savedFormsModule/loadSavedForms').then(() => {
      this.isLoaded = true;
      console.log(',kznjnf');
    });
  }
};
</script>



<style scoped>
.saved-orders-container {
    padding: 0px;
    background: #ffffff;
    margin-top: 12px;
    border-radius: 4px;
    box-shadow: 2px 2px 4px rgb(0 0 0 / 5%);
    overflow: hidden;
}
.block_flex {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.saved-order-card {
   border-bottom: 1px solid #dee2e6;
    border-radius: 0px;
    padding: 10px;
    width: 300px;
    background: #fff;
}
.order-header {
 
    line-height: 12px;
    margin-bottom: 4px;
    position: relative;
    border: 0px;
    padding: 0px;
}
.open-order-button {
    background: linear-gradient(180deg,#22c993,#20a77f)!important;
    color: #ffffff;
    border: none;
    padding: 6px 0;
    cursor: pointer;
    border-radius: 5px;
    width: 100%;
    margin-top: 10px;
    font-weight: 600;
    font-size: 12px;
    box-shadow: 0 4px 6px rgb(0 0 0 / 10%);
    
}

.prew {
    font-size: 10px;
    font-weight: 700;
    width: 100%;
    display: block;
}

.h2 {
background: linear-gradient(180deg, #22c993, #20a77f) !important;
    color: #fff;
    padding: 7px 10px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    text-align: center;
    margin-bottom: 1px;
    border-radius: 0px;
    font-size: 14px;
}

.order-details div {
  line-height: 14px;
    margin-bottom: 5px;
        font-size: 12px;
}

.open-order-button:hover {
  opacity:.7;
}

.no-orders {
  text-align:center;
  margin-top:15px;
}

.close_form {
  position: absolute;
    display: block;
    width: 20px;
    height: 20px;
    right: -6px;
    top: -5px;
    cursor: pointer;
    z-index: 9;
}

.close_form:before {
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'%3E%3Cpath fill='%23FF5353' d='M7.113 6.176a.6.6 0 0 1 .848 0L12 10.214l4.038-4.038a.6.6 0 0 1 .849 0l.937.937a.6.6 0 0 1 0 .848L13.785 12l4.04 4.04a.6.6 0 0 1 0 .848l-.937.937a.6.6 0 0 1-.849 0L12 13.784l-4.038 4.04a.6.6 0 0 1-.849 0l-.937-.937a.6.6 0 0 1 0-.848l4.04-4.04-4.039-4.038a.6.6 0 0 1 0-.849l.937-.936Z'/%3E%3C/svg%3E");
    background-position: 50%;
    background-repeat: no-repeat;
    bottom: 0;
    content: "";
    height: 21px;
    left: 0;
    margin: auto;
    position: absolute;
    right: 0;
    top: 0;
    width: 21px;
}
</style>

